import StaticTree from './StaticTree';

export default StaticTree;
